/**
 * Full-page redirect used for Stripe-hosted pages (Checkout, customer
 * portal). Isolated here so tests can mock it — jsdom cannot navigate.
 */
export function redirectTo(url: string) {
  window.location.assign(url);
}

/** Where signed-in visitors land when there is no page to return to. */
export const DEFAULT_SIGNED_IN_PATH = '/tickers';

const AUTH_PATH = /^\/(signin|signup|reset|auth)(\/|$|\?|#)/;

/**
 * The page to return to after sign-in, taken from router state set by
 * RequireAuth. Only same-origin app paths are honored (no `//host` or
 * `/\host` open redirects), and auth pages fall back to the default so the
 * visitor never lands back on a form.
 */
export function returnPathFrom(state: unknown): string {
  const from = (state as { from?: unknown } | null)?.from;
  if (
    typeof from !== 'string' ||
    !from.startsWith('/') ||
    from.startsWith('//') ||
    from.startsWith('/\\') ||
    AUTH_PATH.test(from)
  ) {
    return DEFAULT_SIGNED_IN_PATH;
  }
  return from;
}
